import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import heroImage from "./../../../assets/images/prp-hero.jpg";
import favicon from "./../../../assets/images/favicon.ico";

import "./advancedhair.css";
//bannerimg
import prp1 from "./../../../assets/images/prp1.jpg";
//before and after
import prp2 from "./../../../assets/images/prp2.jpg";
import prp3 from "./../../../assets/images/prp3.jpg";
import prp4 from "./../../../assets/images/prp4.jpg";

// Import icons
import groHairIcon from "./../../../assets/images/grow-hair treatment-icons.png";
import prpIcon from "./../../../assets/images/prp-treatment-icons1.png";
import gfcIcon from "./../../../assets/images/gfc-treatment-icons.png";
import stmIcon from "./../../../assets/images/treatment.png";
import laserIcon from "./../../../assets/images/laserhair.png";
      import AutoScrollImageRow from "./AutoScrollImageRow";


// Fallback image if main images fail to load
const fallbackImage =
  "https://via.placeholder.com/400x300?text=Image+Not+Available";

// Define schema data for SEO
const schemaData = {
  contactInfo: {
    telephone: "+918870001377",
    email: "info@h-cura.com",
    openingHours: "Mo-Sa 10:00-19:00, Su 10:00-16:00",
    locations: [
      {
        name: "H-Cura Multispeciality Clinic - Bangalore",
        streetAddress:
          "H-Cura Homeopathy Multispecialty Clinic No:779&780 2nd Floor, Sai Towers Building, South, E End Main Rd",
        addressLocality: "Bangalore",
        addressRegion: "Karnataka",
        postalCode: "560069",
        addressCountry: "IN",
        geo: {
          latitude: 12.9257,
          longitude: 77.5838,
        },
      },
      {
        name: "H-Cura Multispeciality Clinic - Chennai",
        streetAddress: "Valasaravakkam",
        addressLocality: "Chennai",
        addressRegion: "Tamil Nadu",
        postalCode: "600087",
        addressCountry: "IN",
      },
    ],
  },
  organizationSchema: {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "H-Cura Multispeciality Clinic",
    url: "https://www.h-cura.com",
    logo: "https://www.h-cura.com/logo.png",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+918870001377",
      contactType: "customer service",
      availableLanguage: ["English", "Tamil"],
    },
    sameAs: [
      "https://www.facebook.com/hcuraclinic",
      "https://www.instagram.com/hcuraclinic",
      "https://twitter.com/hcuraclinic",
    ],
  },
  serviceSchema: {
    "@context": "https://schema.org",
    "@type": "MedicalProcedure",
    name: "PRP Hair Treatment",
    procedureType: "Hair Restoration Therapy",
    howPerformed:
      "Minimally invasive procedure using patient's own platelet-rich plasma",
    preparation: "Detailed scalp analysis and personalized treatment plan",
    followup: "Routine progress reviews and maintenance plans",
    bodyLocation: "Scalp",
    medicalSpecialty: {
      "@type": "MedicalSpecialty",
      name: "Dermatology",
    },
    performedBy: {
      "@type": "MedicalOrganization",
      name: "H-Cura Multispeciality Clinic",
    },
  },
  localBusinessSchema: {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    name: "H-Cura Multispeciality Clinic",
    image: "https://www.h-cura.com/static/media/prp-hero.jpg",
    telephone: "+918870001377",
    email: "info@h-cura.com",
    url: "https://www.h-cura.com/advanced-hair-prp-treatment",
    description:
      "H-Cura is a leading multispeciality clinic offering advanced hair treatments including PRP, GroHair, GFC, STM, and Laser therapies with locations in Bangalore and Chennai.",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "H-Cura Homeopathy Multispecialty Clinic No:779&780 2nd Floor, Sai Towers Building, South, E End Main Rd",
      addressLocality: "Bangalore",
      addressRegion: "Karnataka",
      postalCode: "560069",
      addressCountry: "IN",
    },
    branchOf: {
      "@type": "MedicalClinic",
      name: "H-Cura Multispeciality Clinic - Chennai",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Valasaravakkam",
        addressLocality: "Chennai",
        addressRegion: "Tamil Nadu",
        postalCode: "600087",
        addressCountry: "IN",
      },
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 12.9257,
      longitude: 77.5838,
    },
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ],
        opens: "10:00",
        closes: "19:00",
      },
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Sunday"],
        opens: "10:00",
        closes: "16:00",
      },
    ],
    medicalSpecialty: ["Dermatology", "Trichology"],
    priceRange: "₹₹₹",
  },
};

const treatments = [
  {
    name: "GROHAIR TREATMENT",
    navName: "GROHAIR",
    url: "/advanced-grow-hair-treatment",
  },
  {
    name: "PRP TREATMENT",
    navName: "PRP",
    url: "/advanced-hair-prp-treatment",
  },
  {
    name: "GFC TREATMENT",
    navName: "GFC",
    url: "/advanced-hair-gfc-treatment",
  },
  { name: "STM TREATMENT", navName: "STM", url: "/advanced-stm-treatment" },
  {
    name: "LASER TREATMENT",
    navName: "LASER",
    url: "/advanced-laser-treatment",
  },
];

const treatmentIconPNGMap = {
  GROHAIR: groHairIcon,
  PRP: prpIcon,
  GFC: gfcIcon,
  STM: stmIcon,
  LASER: laserIcon,
};

const images = [
  {
    src: prp2 || fallbackImage,
    alt: "Before and After PRP Hair Treatment Results",
    title: "PRP Treatment Results Comparison",
  },
  {
    src: prp3 || fallbackImage,
    alt: "PRP Hair Treatment Procedure",
    title: "Professional PRP Therapy Process",
  },
  {
    src: prp4 || fallbackImage,
    alt: "Advanced PRP Hair Treatment Equipment",
    title: "State-of-the-art PRP Technology",
  },
];

const faqData = [
  {
    q: "Is PRP hair treatment painful?",
    a: "Most patients experience only mild discomfort during the procedure. A numbing cream is applied to minimize pain.",
  },
  {
    q: "How many PRP sessions are needed for visible results?",
    a: "Typically, 4–6 sessions are recommended for best results, but this may vary depending on individual hair loss patterns.",
  },
  {
    q: "Are there any side effects of PRP therapy?",
    a: "PRP is a safe, autologous treatment. Minor redness or swelling may occur but usually subsides within a day.",
  },
  {
    q: "How soon can I see hair regrowth after PRP?",
    a: "Reduced hair fall is often noticed after 2–3 sessions, with visible regrowth in 3–4 months.",
  },
];

function Hair() {
  const [activeTab, setActiveTab] = useState("PRP TREATMENT");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const navigate = useNavigate();

  // Image error handling
  const handleImageError = (e) => {
    e.target.src = fallbackImage;
    e.target.onerror = null; // Prevent infinite loop
  };

  useEffect(() => {
    document.title =
      "PRP Treatment in India | Best Hair Regrowth Therapy for Hair Loss";

    // Add meta tags and other SEO elements
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "a leading PRP treatment clinic in India, offers expert care from experienced professionals. and PRP hair treatment is an extremely safe and effective method to treat hair problems."
      );
    } else {
      const newMetaDesc = document.createElement("meta");
      newMetaDesc.setAttribute("name", "description");
      newMetaDesc.setAttribute(
        "content",
        "a leading PRP treatment clinic in India, offers expert care from experienced professionals. and PRP hair treatment is an extremely safe and effective method to treat hair problems."
      );
      document.head.appendChild(newMetaDesc);
    }

    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "PRP treatment for hair loss,Best PRP therapy for hair regrowth,Platelet-rich plasma hair treatment,PRP hair restoration,Non-surgical hair regrowth therapy,Effective hair loss solution,Hair thinning treatment with PRP,Advanced PRP therapy for hair,"
      );
    } else {
      const newMetaKeywords = document.createElement("meta");
      newMetaKeywords.setAttribute("name", "keywords");
      newMetaKeywords.setAttribute(
        "content",
        "PRP treatment for hair loss,Best PRP therapy for hair regrowth,Platelet-rich plasma hair treatment,PRP hair restoration,Non-surgical hair regrowth therapy,Effective hair loss solution,Hair thinning treatment with PRP,Advanced PRP therapy for hair,"
      );
      document.head.appendChild(newMetaKeywords);
    }

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-hair-prp-treatment"
      );
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-hair-prp-treatment"
      );
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }

    // Add robots meta tags
    const robotsMeta = document.querySelector("meta[name='robots']");
    if (robotsMeta) {
      robotsMeta.setAttribute(
        "content",
        "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      );
    } else {
      const newRobotsMeta = document.createElement("meta");
      newRobotsMeta.setAttribute("name", "robots");
      newRobotsMeta.setAttribute(
        "content",
        "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      );
      document.head.appendChild(newRobotsMeta);
    }

    // Inject schema.org structured data directly into the head
    // FAQ Schema
    const scriptFaq = document.createElement("script");
    scriptFaq.type = "application/ld+json";
    scriptFaq.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqData.map((faq) => ({
        "@type": "Question",
        name: faq.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.a,
        },
      })),
    });
    document.head.appendChild(scriptFaq);

    // Organization Schema
    const scriptOrg = document.createElement("script");
    scriptOrg.type = "application/ld+json";
    scriptOrg.innerHTML = JSON.stringify(schemaData.organizationSchema);
    document.head.appendChild(scriptOrg);

    // Service Schema
    const scriptService = document.createElement("script");
    scriptService.type = "application/ld+json";
    scriptService.innerHTML = JSON.stringify(schemaData.serviceSchema);
    document.head.appendChild(scriptService);

    // Local Business Schema
    const scriptBusiness = document.createElement("script");
    scriptBusiness.type = "application/ld+json";
    scriptBusiness.innerHTML = JSON.stringify(schemaData.localBusinessSchema);
    document.head.appendChild(scriptBusiness);

    // Cleanup on unmount
    return () => {
      if (document.head.contains(scriptFaq))
        document.head.removeChild(scriptFaq);
      if (document.head.contains(scriptOrg))
        document.head.removeChild(scriptOrg);
      if (document.head.contains(scriptService))
        document.head.removeChild(scriptService);
      if (document.head.contains(scriptBusiness))
        document.head.removeChild(scriptBusiness);
    };
  }, []);

  useEffect(() => {
    // Get the current path from window.location
    const path = window.location.pathname;
    const matchingTreatment = treatments.find(
      (t) => t.url.toLowerCase() === path.toLowerCase()
    );
    if (matchingTreatment) {
      setActiveTab(matchingTreatment.name);
    }
    // Original effect code for process steps
    const steps = document.querySelectorAll(".hc-process-step");
    steps.forEach((step, index) => {
      step.style.setProperty("--index", index);
      step.style.opacity = "1";
    });
  }, []);

  const renderTreatmentIcon = (name, fallbackIcon) => {
    return treatmentIconPNGMap[name] ? (
      <img
        src={treatmentIconPNGMap[name]}
        alt={`${name} Hair Treatment Icon`}
        title={`${name} Hair Treatment Option`}
        style={{ width: "100px", height: "100px" }}
        onError={handleImageError}
      />
    ) : (
      fallbackIcon || <div className="icon-placeholder">{name.charAt(0)}</div>
    );
  };

  const openModal = (image) => {
    setModalImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage(null);
  };

  const handleTreatmentClick = (treatment) => {
    setActiveTab(treatment.name);
    navigate(treatment.url);
  };

  return (
    <div className="hc-wrapper">
      {/* New Navigation Section */}
      <div className="hc-treatment-nav-container">
        <h2>Explore Our Treatments</h2>
        <div className="hc-treatment-nav-cards">
          {treatments.map((treatment) => (
            <div
              key={treatment.name}
              className={`hc-treatment-nav-card \${
                activeTab === treatment.name ? "active" : ""
              }`}
              style={{
                position: "relative",
                borderBottom:
                  activeTab === treatment.name ? "3px solid #007bff" : "none",
                transition: "border-bottom 0.3s ease",
                cursor: "pointer",
              }}
              onClick={() => handleTreatmentClick(treatment)}
            >
              <div className="hc-card-icon">
                {renderTreatmentIcon(treatment.navName)}
              </div>
              <div
                className="hc-card-title"
                style={{
                  color: ["GROHAIR", "PRP", "GFC", "STM", "LASER"].includes(
                    treatment.navName
                  )
                    ? "#007bff"
                    : "black",
                }}
              >
                {treatment.name.replace(" TREATMENT", "")}
                <span style={{ color: "black" }}> TREATMENT</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Hero Section */}
      <section
        className="hc-hero"
        style={{
          position: "relative",
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${
            heroImage || fallbackImage
          })`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        title="PRP Hair Treatment Hero Banner"
      >
        {/* Hidden image for SEO & tooltip on hover */}
        <img
          src={heroImage || fallbackImage}
          alt="PRP Hair Treatment at H-Cura Clinic - Natural Hair Regrowth and Scalp Therapy"
          title="PRP Hair Treatment at H-Cura Clinic - Natural Hair Regrowth"
          className="hero-seo-img"
          onError={handleImageError}
          style={{
            position: "absolute",
            width: "1px",
            height: "1px",
            opacity: 0,
          }}
        />

        <div className="hc-hero-content">
          <h1 className="hc-hero-title">
            Advanced Hair PRP Treatment in Bangalore & Chennai
          </h1>
          <p className="hc-hero-text">
            Harness the power of your own platelets to naturally rejuvenate your
            scalp and restore hair density.
          </p>
          <Link
            to="/bookconsultation"
            style={{ textDecoration: "none", cursor: "pointer" }}
            className="hc-cta-button"
          >
            Book Consultation
          </Link>
        </div>
      </section>

      {/* Treatment Section */}
      <section className="hc-treatment-section" id="treatments">
        <div className="hc-treatment-container">
          <div className="hc-treatment-nav">
            <h2>Revitalize Your Hair with Our Advanced Treatments</h2>
            <p className="hc-nav-description">
              Whether it's growth factor boosters or premium PRP treatments, each solution is crafted to stimulate your scalp’s natural hair-regrowing ability.
            </p>
            <ul>
              <li className="hc-active">
                <strong>Gro Hair Therapy</strong>
                <p>Stimulate hair follicles & helps in hair regrowth.</p>
                <ul className="hc-treatment-details">
                  <li>Painless process & noninvasive procedure</li>
                  <li>Helps in control hairfall</li>
                  <li>Quick visible results</li>
                  <li>Reduce dandruff</li>
                </ul>
              </li>
              <li className="hc-active">
                <strong>Growth Factor Concentrate</strong>
                <p>Stimulate hair follicles & helps in hair regrowth.</p>
                <ul className="hc-treatment-details">
                  <li>Autologous treatment</li>
                  <li>No synthetic additives</li>
                  <li>Boosts regeneration</li>
                </ul>
              </li>
              <li>
                <strong>PRP Therapy</strong>
                <p>
                  Restore your hair naturally by plasma rich protein therapy.
                </p>
                <ul className="hc-treatment-details">
                  <li>Concentrated with powerful growth factors</li>
                  <li>Supports deep tissue repair and regeneration</li>
                  <li>Offers strong, long-lasting results</li>
                </ul>
              </li>
              <li>
                <strong>Stem Cell Treatment</strong>
                <p>Rejuvenate your hair using regenerative technology.</p>
                <ul className="hc-treatment-details">
                  <li>Pain-free procedure</li>
                  <li>It stimulates hair follicles</li>
                  <li>Hair boosting therapy</li>
                  <li>Quick sessions</li>
                </ul>
              </li>
              <li>
                <strong>Laser Hair Therapy</strong>
                <p>Enhance hair density with precision laser treatments.</p>
                <ul className="hc-treatment-details">
                  <li>Pain-free procedure</li>
                  <li>It stimulates hair follicles</li>
                  <li>Hair boosting therapy</li>
                  <li>Quick sessions</li>
                </ul>
              </li>
            </ul>
         
          </div>

          <div className="hc-treatment-content">
            <h3>
              Regrow Your Hair Naturally with Advanced PRP Therapy at H‑Cura
            </h3>
            <div className="hc-treatment-info">
              <div className="hc-treatment-images">
                <img
                  src={prp1 || fallbackImage}
                  alt="Advanced PRP Hair Treatment Process"
                  title="PRP Hair Restoration Therapy"
                  className="hc-main-treatment-image"
                  onError={handleImageError}
                />

                <div className="hc-treatment-gallery">
                  {images.map((image, index) => (
                    <img
                      key={index}
                      src={image.src}
                      alt={image.alt}
                      title={image.title}
                      onClick={() => openModal(image)}
                      onError={handleImageError}
                    />
                  ))}
                </div>
                <div className="hc-treatment-highlight-info">
                  Experience scientifically proven, minimally invasive hair
                  regrowth with Advanced PRP Treatment at H‑Cura Multispecialty
                  Clinic. Now available at our Jayanagar (Bangalore) and
                  Valasaravakkam (Chennai) branches, this medically proven
                  therapy harnesses your body's own healing factors to stimulate
                  hair follicles and promote natural regrowth, resulting in
                  thicker, healthier hair.
                </div>
              </div>

              <div className="hc-treatment-description">
                <h4>Revolutionary Hair Growth Technology</h4>
                <div className="hc-treatment-intro">
                  <Link
                    to="/bookconsultation"
                    style={{ textDecoration: "none" }}
                  >
                    <span className="hc-highlight-tag">Advanced Treatment</span>
                  </Link>
                  <p className="hc-lead-text">
                    Experience the future of hair restoration with our
                    clinically-proven PRP Treatment.
                  </p>
                </div>

                <div className="hc-key-benefits">
  <h5>How This Treatment Helps Your Hair</h5>
  <p>
    This advanced therapy uses your own platelets and growth factors to deliver
    fast, natural hair restoration.
  </p>

  <ul>
    <li>
      <span className="hc-benefit-icon">🔬</span>
      <strong>Activates Follicles</strong>
      <p>Wakes up dormant follicles to trigger new growth.</p>
    </li>

    <li>
      <span className="hc-benefit-icon">📈</span>
      <strong>Improves Density</strong>
      <p>Enhances hair volume and thickness.</p>
    </li>

    <li>
      <span className="hc-benefit-icon">🌱</span>
      <strong>Natural Regrowth</strong>
      <p>Supports healthy, natural-looking results.</p>
    </li>

    <li>
      <span className="hc-benefit-icon">💪</span>
      <strong>Strengthens Hair</strong>
      <p>Reduces breakage and boosts hair quality.</p>
    </li>
  </ul>
</div>


                <div className="hc-treatment-highlights">
                  <div className="hc-highlight-box">
                    <h5>Success Rate</h5>
                    <p>92%</p>
                    <span className="hc-subtitle">Satisfied Clients</span>
                  </div>
                  <div className="hc-highlight-box">
                    <h5>Treatment Time</h5>
                    <p>45-60 mins</p>
                    <span className="hc-subtitle">Per Session</span>
                  </div>
                  <div className="hc-highlight-box">
                    <h5>Recovery</h5>
                    <p>Minimal</p>
                    <span className="hc-subtitle">
                      Resume activities same day
                    </span>
                  </div>
                  <div className="hc-highlight-box">
                    <h5>Result</h5>
                    <p>4-6 sessions</p>
                    <span className="hc-subtitle">for visible results</span>
                  </div>
                </div>

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                  <button className="hc-book-treatment-btn">
                    Schedule Your Consultation
                    <span className="hc-btn-icon">→</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hc-process-section prp-treatment-simple">
        <div className="prp-treatment-wrapper">
          <div className="hc-benefits-header">
            <div className="hc-section-tag">Hair PRP Treatment</div>
            <h2>What is Advanced Hair PRP Treatment?</h2>
          </div>

          <p>
            Advanced Hair PRP Treatment is a modern, minimally invasive procedure that uses the healing potential of your own platelets to boost natural hair regrowth. It reactivates hair follicles, enhances scalp circulation, and supports healthier, stronger hair growth.
          </p>

          <p>This treatment typically involves:</p>

          <ul>
            <li>A small amount of your blood is collected</li>
            <li>
             It is processed to isolate platelet-rich plasma (PRP)
            </li>
            <li>
              The concentrated PRP is then carefully injected into the scalp to awaken dormant follicles
            </li>
          </ul>

          <p>
          The outcome? Naturally fuller, thicker hair and an overall healthier scalp.
          </p>

          <p>
            At H-Cura, we use a triple-spin PRP system to achieve a highly concentrated level of growth factors, ensuring more effective and longer-lasting results
          </p>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="hc-benefits-section">
  <div className="hc-benefits-header">
    <span className="hc-section-tag">Why Patients Trust Us</span>
    <h2>Premium Hair Restoration Care at H-Cura Multispeciality Clinic</h2>
    <p className="hc-section-subtitle">
      We combine advanced medical innovation with compassionate, personalized care to help you regain fuller, healthier hair with confidence.
    </p>
  </div>

  <div className="hc-benefits-grid">
    {[
      {
        icon: "🔬",
        title: "Advanced Medical Technology",
        desc: "We use cutting-edge PRP systems and scientific protocols to ensure maximum hair follicle activation.",
        features: [
          "Next-Gen PRP Systems",
          "Scientifically Backed Methods",
          "High-Efficiency Growth Factor Delivery",
        ],
      },
      {
        icon: "👨‍⚕",
        title: "Specialized Hair Experts",
        desc: "Our experienced medical team focuses exclusively on hair restoration for safe, precise, and effective results.",
        features: [
          "Certified Hair Specialists",
          "Extensive Clinical Expertise",
          "One-on-One Medical Guidance",
        ],
      },
      {
        icon: "🎯",
        title: "Tailored Treatment Plans",
        desc: "Your therapy is designed according to your scalp condition, medical history, and expected hair growth goals.",
        features: [
          "Customized PRP Sessions",
          "Regular Growth Assessments",
          "Optimized Treatment Scheduling",
        ],
      },
      {
        icon: "✨",
        title: "Naturally Enhanced Results",
        desc: "Achieve thicker, stronger hair with outcomes that blend seamlessly with your natural look and hairline.",
        features: [
          "Natural Growth Patterns",
          "Visible Volume Improvement",
          "Long-Lasting Hair Density",
        ],
      },
      {
        icon: "🛡",
        title: "Safe & Hygienic Environment",
        desc: "We maintain strict medical standards to ensure every procedure is performed in a sterile and secure setting.",
        features: [
          "Fully Sanitized Clinical Setup",
          "Rigorous Safety Measures",
          "Patient-Focused Approach",
        ],
      },
      {
        icon: "💯",
        title: "Trusted & Effective Results",
        desc: "Thousands of patients have experienced significant hair regrowth and renewed confidence with our treatments.",
        features: [
          "High Patient Satisfaction",
          "Consistent Positive Outcomes",
          "Proven Regrowth Success",
        ],
      },
    ].map((benefit, index) => (
      <div className="hc-benefit-card" key={index}>
        <div className="hc-benefit-icon">{benefit.icon}</div>
        <div className="hc-benefit-content">
          <h3>{benefit.title}</h3>
          <p>{benefit.desc}</p>
          <ul className="hc-feature-list">
            {benefit.features.map((feature, idx) => (
              <li key={idx}>{feature}</li>
            ))}
          </ul>
        </div>
      </div>
    ))}
  </div>
</section>


      {/* Process Section */}
      <section className="hc-process-section" id="process">
  <div className="hc-process-header">
    <span className="hc-process-tag">Treatment Process</span>
    <h2>Your Step-by-Step Path to Hair Renewal</h2>
    <p className="hc-process-subtitle">
      Follow our seamless 4-step system designed to deliver natural, long-lasting hair regrowth.
    </p>
  </div>

  <div className="hc-process-timeline">
    {[
      {
        step: "01",
        title: "Detailed Initial Assessment",
        desc: "Your transformation begins with a complete evaluation of your scalp and hair health to identify the best approach.",
        details: [
          "Advanced scalp examination",
          "Medical & lifestyle review",
          "Hair density and root analysis",
          "Clear treatment recommendations",
        ],
        icon: "🔍",
      },
      {
        step: "02",
        title: "Personalized Treatment Blueprint",
        desc: "We craft a tailored PRP strategy based on your hair condition, expectations, and biological profile.",
        details: [
          "Custom PRP plan creation",
          "Precision platelet concentration",
          "Session roadmap planning",
          "Growth optimization guidance",
        ],
        icon: "📋",
      },
      {
        step: "03",
        title: "Advanced PRP Procedure",
        desc: "Our specialists perform a highly controlled PRP session to activate dormant follicles and boost natural growth.",
        details: [
          "Clinical-grade setup",
          "Accurate PRP injections",
          "Enhanced follicle stimulation",
          "Quick and comfortable session",
        ],
        icon: "💉",
      },
      {
        step: "04",
        title: "Ongoing Support & Aftercare",
        desc: "We monitor your progress closely to fine-tune treatment and ensure long-lasting improvements.",
        details: [
          "Regular follow-up check-ins",
          "Progress-based adjustments",
          "Preventive care strategies",
          "Continuous expert assistance",
        ],
        icon: "📈",
      },
    ].map((process, index) => (
      <div className="hc-process-step" key={index}>
        <div className="hc-step-container">
          <div className="hc-step-number-container">
            <div className="hc-step-number">{process.step}</div>
            <div className="hc-step-icon">{process.icon}</div>
          </div>
          <div className="hc-step-content">
            <h3>{process.title}</h3>
            <p className="hc-step-description">{process.desc}</p>
            <ul className="hc-step-details">
              {process.details.map((detail, idx) => (
                <li key={idx}>{detail}</li>
              ))}
            </ul>
          </div>
        </div>
        {index < 3 && <div className="hc-connector-line"></div>}
      </div>
    ))}
  </div>
</section>


      {/* FAQ Section */}
      <section className="hc-faq-section">
        <div className="hc-faq-header">
          <span className="hc-section-tag">FAQs</span>
          <h2 className="hc-faq-title">Frequently Asked Questions</h2>
        </div>
        <div className="hc-faq-list">
          {faqData.map((faq, idx) => (
            <details className="hc-faq-item" key={idx}>
              <summary className="hc-faq-question">
                <span className="hc-faq-q">Q{idx + 1}:</span> {faq.q}
                <span className="hc-faq-toggle-icon">+</span>
              </summary>
              <div className="hc-faq-answer">
                <span className="hc-faq-a">A:</span> {faq.a}
              </div>
            </details>
          ))}
        </div>
      </section>
            <AutoScrollImageRow />



      {/* Modal for Image Viewing */}
      {isModalOpen && (
        <div className="hc-modal-overlay" onClick={closeModal}>
          <div
            className="hc-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="hc-close-modal" onClick={closeModal}>
              &times;
            </button>
            <img
              src={modalImage?.src || fallbackImage}
              alt={modalImage?.alt || "Treatment Image"}
              title={modalImage?.title || "PRP Treatment Image"}
              className="hc-modal-image"
              style={{ maxWidth: "100%", borderRadius: "8px" }}
              onError={handleImageError}
            />
          </div>
        </div>
      )}

      {/* Add custom CSS for image placeholders and error states */}
      {/* <style>{`
        .icon-placeholder {
          width: 100px;
          height: 100px;
          background-color: #f0f0f0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: bold;
          color: #007bff;
          border-radius: 50%;
        }
        
        .hero-seo-img {
          position: absolute;
          width: 1px;
          height: 1px;
          opacity: 0;
          pointer-events: none;
        }
        
        img.error {
          background-color: #f8f8f8;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }
        
        img.error::after {
          content: '🖼️ Image not available';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #666;
        }
      `}</style> */}
    </div>
  );
}

export default Hair;
